import * as ga from "../../lib/ga";

export const teaserTracker = (
  sectionTitle: string,
  sectionBlockIndex: number,
  linkText: string,
  url: string
) => {
  const trackingData = {
    event: "teaser_click",
    event_parameters: {
      page_location: window.location.href,
      title: sectionTitle,
      index: sectionBlockIndex,
      link_text: linkText,
      link_url: url,
    },
  };
  ga.gaTracking(trackingData);
};
